import { Auth } from 'aws-amplify';
import env from '~env';
import {
  ApiClient,
  type ApiClientConfig,
  type GetAuthTokenFn,
} from '../api-client';
import { getNizza } from '../nizza-store';

/**
 * Retrieves JWT token from AWS Amplify or Nizza store.
 * @returns JWT string or null if unavailable
 */
const nzGetAuthToken: GetAuthTokenFn = async (): Promise<string | null> => {
  try {
    const session = await Auth.currentSession();
    return session.getIdToken().getJwtToken();
  } catch {
    return getNizza().config?.authToken ?? null;
  }
};

const nzApiClientConfig: ApiClientConfig = {
  restApiBaseUrl: env.apiUrls.restV2,
  graphqlApiBaseUrl: env.apiUrls.graphql,
  logger: getNizza().coreLogger,
  getAuthToken: nzGetAuthToken,
};

/**
 * Singleton instance of the ApiClient configured for the "nizza" project.
 * Use this client for all REST and GraphQL communication with the "core-services" backend.
 */
export const nzApiClient = new ApiClient(nzApiClientConfig);
